// Port of api/fuel/app/classes/filter/search/games/rules/query/tag_families.php
import Rule from 'offline/filter/core/search/rule'
import DB from 'offline/db'
import Util from 'offline/util'
import F from 'offline/filter/constants'

function attachedContextIndex(fieldName, rule, config) {
	var index = Rule.valueAsIndex(rule)
	if (!index.length) return [0]

	if (!config || config.resultType === F.RESULT_GAME) {
		return Util.pluck(DB.query(
			'SELECT game_id FROM tag_attach WHERE game_id > 0 AND ' + fieldName + ' IN(' + Util.in(index) + ')'
		), 'game_id')
	}

	var contextField = F.RESULT_TABLE[config.resultType] + '_id'
	var contextIndex = Util.pluck(DB.query(
		'SELECT ' + contextField + ' FROM tag_attach WHERE ' + contextField + ' > 0 AND ' + fieldName + ' IN(' + Util.in(index) + ')'
	), contextField)

	var gameIndex = Util.pluck(DB.query(
		'SELECT game_id FROM tag_attach WHERE game_id > 0 AND ' + fieldName + ' IN(' + Util.in(index) + ')'
	), 'game_id')

	if (gameIndex.length && config.users && config.users.length) {
		var groupedRows = DB.query(
			'SELECT ' + contextField + ', game_id FROM ' + F.RESULT_TABLE[config.resultType] + ' WHERE user_id IN(' + Util.in(config.users) + ') AND game_id IN(' + Util.in(gameIndex) + ')'
		)
		for (var i = 0; i < groupedRows.length; i++) {
			contextIndex.push(groupedRows[i][contextField])
		}
	}

	return contextIndex
}

export default Rule.create({
	name: 'tag_families',
	isIndex: function() { return 'tag' },
	field: function() {
		var config = this._config
		if (config && config.resultType) {
			return F.RESULT_RELATION[config.resultType] + '.' + F.RESULT_TABLE[config.resultType] + '_id'
		}
		return 'g.game_id'
	},
	// Custom gameIndex for tag families: queries tag_attach by family_id
	oneof: function(rule, config, filter, data, query) {
		var ids = Rule.setFilter(rule, 'one', attachedContextIndex('family_id', rule, config))
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where(this.field(rule), opMap, ids)
	},
	someof: function(rule, config, filter, data, query) {
		var ids = Rule.setFilter(rule, 'some', attachedContextIndex('family_id', rule, config))
		query.where(this.field(rule), 'in', ids)
	},
	allof: function(rule, config, filter, data, query) {
		var ids = Rule.setFilter(rule, 'all', attachedContextIndex('family_id', rule, config))
		query.where(this.field(rule), 'in', ids)
	},
	match: function(rule, config, filter, data, query) {
		var ids = Rule.setFilter(rule, 'one', attachedContextIndex('family_id', rule, config))
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where(this.field(rule), opMap, ids)
	}
})
